import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AUTHENTICATION_ROUTES } from "./authentication.routes";
import { AuthenticationComponent } from './components/authentication/authentication.component';
import { LoginComponent } from './components/login/login.component';
import { OtpComponent } from "./components/otp/otp.component";
import { ToastModule } from 'primeng/toast';
import { MessageService } from "primeng/api";
import { INTERCEPTOR_PROVIDER } from "src/app/core/interceptors/interceptor-provider";
import { ForgetEmailComponent } from "./components/forget-email/forget-email.component";
import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { SuccessComponent } from "./components/success/success.component";
import { VendorRegistrationComponent } from "./components/vendor-registration/vendor-registration.component";
import { ProgressBarComponent } from "./components/progress-bar/progress-bar.component";
import { FormValidationService } from "src/app/shared/services/form-validation.service";
import { RequiredFieldDirective } from 'src/app/shared/helpers/required-field.directive'; // Adjust path as needed
import { LoaderService } from "src/app/shared/services/loader.service";
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { AutoTabDirective } from "src/app/shared/helpers/auto-tab.directive";
import { profile } from "console";
import { MatDialogModule } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";


@NgModule({
    declarations: [
    
    AuthenticationComponent,
    LoginComponent,
    OtpComponent,
    ForgetEmailComponent,
    ChangePasswordComponent,
    SuccessComponent,
    VendorRegistrationComponent,
    ProgressBarComponent,
    
   // AutoTabDirective
  ],
    imports: [
        CommonModule, // Add CommonModule here
        AUTHENTICATION_ROUTES,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        HttpClientModule,
        SharedModule,
        TranslateModule,
        CommonModule,
        
        
    ],
    exports: [
      ProgressBarComponent, // Export the component here

    ],
    providers: [
      INTERCEPTOR_PROVIDER,
      MessageService,
      FormValidationService
    ]
})
export class AuthenticationModule {}
